export default {
  computed: {
    mobileFavoritesMenu() {
      return this.$store.getters.MOBILE_FAVORITES_MENU;
    },
    favoriteItems() {
      let favorites = [];

      if (this.album && this.favorites && this.favorites.length > 0) {
        this.favorites.forEach((album) => {
          if (album.albumId === this.album.id) {
            album.items.forEach((photo) => {
              favorites.push(photo);
            });
          }
        });
      }

      return favorites;
    },
    favoriteItemsLength() {
      return this.favoriteItems.length;
    },
  },
  methods: {
    goTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path);
      }

      this.$store.dispatch('SET_MOBILE_FAVORITES_MENU', false);
    },
    getDownloadPhotos(items) {
      return items.filter((item) => +item.freeDownload);
    },
    orderSelected(reload = true) {
      if (this.album && this.album.id) {
        this.$store.dispatch('SET_MOBILE_FAVORITES_MENU', false);

        const favorites = this._.find(this.favorites, {
          albumId: this.album.id,
        });

        const favoritePhotos = favorites && favorites.items
            ? favorites.items
            : [];

        const photos = favoritePhotos.map((item) => {
          return this._.find(this.album.album_items, {id: item.photoId});
        });

        this.handleOrder(photos, reload);
      }
    },
    handleOrder(photos, reload = true) {
      this.$store.dispatch('INIT_ORDER');

      const order = this.myOrder;
      order.quantity = photos.length;

      this.$store.dispatch('SET_MASS', true);
      this.$store.dispatch('SET_PHOTO', this._.first(photos));
      this.$store.dispatch('SET_PHOTOS', photos);
      this.$store.dispatch('SET_ORDER', order);

      if (reload) {
        this.$router.push(
            this.i18nLink(`album/gallery/${this.getAlbumId()}/order`));
      }
    },
  },
};
